<div *ngIf="isVisible" class="overlay">
    <!-- Botón de cierre reposicionado fuera del diálogo principal -->
    <button class="close-button" (click)="closeDialog()">✕</button>
    
    <div class="dialog-container">
        <!-- Título -->
        <div>
            <h3 class="title">Escoge tu programa y afíliate ahora</h3>
        </div>

        <!-- Estado de carga -->
        <div *ngIf="loading" class="loading-container">
            <p class="loading-text">Cargando programas disponibles...</p>
        </div>
        
        <!-- Estado de error -->
        <div *ngIf="error" class="error-container">
            <p class="error-message">{{ error }}</p>
            <button class="retry-button" (click)="loadSubscriptionTypes()">Reintentar</button>
        </div>

        <!-- Contenido principal cuando no hay carga ni error -->
        <div *ngIf="!loading && !error">
            <!-- Botones de selección de período -->
            <!-- <div class="container-buttons">
                <div class="toggle-buttons">
                    <button class="toggle-button" [class.active]="selectedPlan === 'anual'" (click)="togglePlan('anual')">Anual -15%</button>
                    <button class="toggle-button" [class.active]="selectedPlan === 'trimestral'" (click)="togglePlan('trimestral')">Trimestral</button>
                </div>
            </div> -->

            <!-- Tres planes en una grid -->
            <div class="plan-options">
                <!-- PLAN FREEMIUM -->
                <div class="plan-card">
                    <div class="plan-header">
                        <p class="p-regular">Programa para empezar y conocer mejor la plataforma.</p>
                        <h2>{{ freemiumPlan?.name || 'Freemium' }}</h2>
                    </div>
                    
                    <!-- <div class="plan-price">
                        <h3 class="price">S/.{{ getDisplayPrice('freemium') }}</h3>
                        <p class="price-detail">No tienes que pagar nada</p>
                    </div> -->
                    
                    <div class="plan-action">
                        <button class="action-button" (click)="subscribeToPlan('freemium')">Continuar Gratis</button>
                    </div>
                    
                    <div class="separator-line"></div>
                    
                    <div class="plan-features">
                        <p class="features-title">Incluye:</p>
                        <ul class="features-list">
                            <li *ngFor="let detail of getPlanDetails('freemium')">{{ detail }}</li>
                            <!-- Agrega placeholders si no hay detalles -->
                            <ng-container *ngIf="getPlanDetails('freemium').length === 0">
                                <li>Acceso a la plataforma básica</li>
                                <li>Funcionalidades limitadas</li>
                            </ng-container>
                        </ul>
                    </div>
                </div>
                
                <!-- PLAN PROFESSIONAL -->
                <div class="plan-card" [class.recommended-card]="isPlanHighlighted('professional')">
                    <!-- <div class="recommended-badge" *ngIf="isPlanHighlighted('professional')">{{ getHighlightText('professional') }}</div> -->
                    
                    <div class="plan-header" [class.pt-40]="isPlanHighlighted('professional')">
                        <p class="p-regular">Programa profesional con evaluaciones completas y mentoría.</p>
                        <h2>{{ professionalPlan?.name || 'Professional' }}</h2>
                    </div>
                    
                    <!-- <div class="plan-price">
                        <h3 class="price">S/.{{ getDisplayPrice('professional') }}</h3>
                        <p class="price-detail">Facturado {{ selectedPlan === 'anual' ? 'anualmente' : 'trimestralmente' }} por S/.{{ getTotalPrice('professional') }}</p>
                    </div> -->
                    
                    <div class="plan-action">
                        <button class="action-button" (click)="subscribeToPlan('professional')">Próximamente</button>
                        <p class="contact-text">¿Dudas? 
                            <a [routerLink]="['/contact-us']">Contáctanos</a>
                        </p>
                    </div>
                    
                    <div class="separator-line"></div>
                    
                    <div class="plan-features">
                        <p class="features-title">Todo lo de {{ getPreviousPlanName('professional') }} además de:</p>
                        <ul class="features-list">
                            <li *ngFor="let detail of getPlanDetails('professional')">{{ detail }}</li>
                            <!-- Agrega placeholders si no hay detalles -->
                            <ng-container *ngIf="getPlanDetails('professional').length === 0">
                                <li>Acceso completo a la plataforma</li>
                                <li>Evaluaciones avanzadas</li>
                                <li>Mentoría básica</li>
                            </ng-container>
                        </ul>
                        
                        <!-- Servicios bajo demanda si existen -->
                        <ng-container *ngIf="getPlanOnDemand('professional').length > 0">
                            <p class="features-title mt-3">Servicios bajo demanda:</p>
                            <ul class="features-list">
                                <li *ngFor="let onDemand of getPlanOnDemand('professional')">{{ onDemand }}</li>
                            </ul>
                        </ng-container>
                    </div>
                </div>
                
                <!-- PLAN EXECUTIVE -->
                <div class="plan-card" [class.recommended-card]="isPlanHighlighted('executive')">
                    <div class="recommended-badge" *ngIf="isPlanHighlighted('executive')">{{ getHighlightText('executive') }}</div>
                    
                    <div class="plan-header" [class.pt-40]="isPlanHighlighted('executive')">
                        <p class="p-regular">Programa ejecutivo con mentoría personalizada y acceso premium.</p>
                        <h2>{{ executivePlan?.name || 'Executive' }}</h2>
                    </div>
                    
                    <!-- <div class="plan-price">
                        <h3 class="price">S/.{{ getDisplayPrice('executive') }}</h3>
                        <p class="price-detail">Facturado {{ selectedPlan === 'anual' ? 'anualmente' : 'trimestralmente' }} por S/.{{ getTotalPrice('executive') }}</p>
                    </div> -->
                    
                    <div class="plan-action">
                        <button class="action-button" (click)="subscribeToPlan('executive')">Próximamente</button>
                        <p class="contact-text">¿Dudas? 
                            <a [routerLink]="['/contact-us']">Contáctanos</a>
                        </p>
                    </div>
                    
                    <div class="separator-line"></div>
                    
                    <div class="plan-features">
                        <p class="features-title">Todo lo de {{ getPreviousPlanName('executive') }} además de:</p>
                        <ul class="features-list">
                            <li *ngFor="let detail of getPlanDetails('executive')">{{ detail }}</li>
                            <!-- Agrega placeholders si no hay detalles -->
                            <ng-container *ngIf="getPlanDetails('executive').length === 0">
                                <li>Mentoría personalizada</li>
                                <li>Acceso a todos los recursos</li>
                                <li>Soporte prioritario</li>
                                <li>Beneficios exclusivos</li>
                            </ng-container>
                        </ul>
                        
                        <!-- Servicios bajo demanda si existen -->
                        <ng-container *ngIf="getPlanOnDemand('executive').length > 0">
                            <p class="features-title mt-3">Servicios bajo demanda:</p>
                            <ul class="features-list">
                                <li *ngFor="let onDemand of getPlanOnDemand('executive')">{{ onDemand }}</li>
                            </ul>
                        </ng-container>
                    </div>
                </div>
            </div>

            <!-- Texto de más detalles -->
            <div class="more-details">
                <p class="details-link" (click)="navigateToPlansView()">Mira más detalles del programa</p>
            </div>
        </div>
    </div>
</div>